export class MentalSymbolMultiplier extends PIXI.Container {
    public multi: PIXI.BitmapText;

    constructor(multiplierValue: number) {
        super();
        this.createMultiplier(multiplierValue);
    }

    public updateMultiplier(value: number): void {
        this.multi.fontSize = 10;
        this.multi.text = "x" + value;
        while (this.multi.textWidth > 144) {
            this.multi.fontSize--;
        }
        this.multi.position.set(144 - (this.multi.width + 10), 0);
    }

    private createMultiplier(value: number): void {
        this.multi = new PIXI.BitmapText("x" + value, {
            fontName: "MultiplierWinCountUp",
            fontSize: 10
        });
        this.visible = false;
        this.updateMultiplier(value);
        this.addChild(this.multi);
    }
}